import React from "react";
import {
  Container,
  Desc,
  Greeting,
  Image,
  ImageHolder,
  Left,
  Main,
  Name,
  Right,
  Wrapper,
} from "./About.Elements";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import "./about.css";

const About = () => {
  return (
    <>
      <Container>
        <Header view='blog' />
        {/* <Title>About the author</Title> */}
        <Wrapper>
          <Main>
            <Left>
              <ImageHolder>
                <Image
                  src='https://res.cloudinary.com/sumailcodes/image/upload/v1653164136/IMG_20191119_180011_2_nrjjyh.jpg'
                  alt='author image'
                />
              </ImageHolder>
            </Left>
            <Right>
              <Greeting className='greet'>Hey, there</Greeting>
              <Name className='name'>I'M SUMAIL SHAIK</Name>
              <Desc className='desc'>
                A Web Developer and Programmer living in India. I will Design &
                Build Web applications using MERN Technology. I am also curios
                to know about technologies and love to write articles in my Blog
                application.
              </Desc>
            </Right>
          </Main>
        </Wrapper>
      </Container>
      <div
        style={{
          backgroundColor: "#2f3133",
          color: "white",
          width: "100%",
        }}
      >
        <Footer />
      </div>
    </>
  );
};

export default About;
